module.exports = __webpack_public_path__ + "static/media/black_navbar_icon.93198839.svg";